// extracted by mini-css-extract-plugin
export var productImage = "_ng-0";